import React, { Component } from 'react';
import Layout from 'src/ui/layout';
import intl from 'react-intl-universal';
import { isCorpClientSelector, isRestrictedCorpMemberSelector } from '../../../ui/features/Login/state/loginReselect';
import { connect } from 'react-redux';
import { mainDashboardRoute } from 'src/newDashboardRoutes';

class NewDashboardRoot extends Component {
  componentDidMount() {}
  componentWillUnmount() {}
  render() {
    const { isCorpClient, isRestrictedCorpMember } = this.props;
    const userPageTitle = isCorpClient
      ? 'dashboard.corpPageTitle'
      : isRestrictedCorpMember
      ? 'dashboard.restrictedCorpPageTitle'
      : 'dashboard.employeePageTitle';
    return <Layout headerName={'New ' + intl.get(userPageTitle)}>{mainDashboardRoute}</Layout>;
  }
}
// export default NewDashboardRoot;
const mapStateToProps = state => {
  return {
    isCorpClient: isCorpClientSelector(state),
    isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(NewDashboardRoot);
